import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import SystemStatusIndicator from '../../components/ui/SystemStatusIndicator';
import ComplianceAlertBanner from '../../components/ui/ComplianceAlertBanner';
import UserContextSwitcher from '../../components/ui/UserContextSwitcher';
import QuickActionToolbar from '../../components/ui/QuickActionToolbar';
import TradingInterface from './components/TradingInterface';
import PortfolioPanel from './components/PortfolioPanel';
import AutomatedTriggers from './components/AutomatedTriggers';
import RiskAssessment from './components/RiskAssessment';
import MarketInsights from './components/MarketInsights';
import Icon from '../../components/AppIcon';

const EUATradingHub = () => {
  const [activeTab, setActiveTab] = useState('trading');

  const tabs = [
    { id: 'trading', label: 'Live Trading', icon: 'TrendingUp' },
    { id: 'portfolio', label: 'Portfolio', icon: 'PieChart' },
    { id: 'triggers', label: 'Auto Triggers', icon: 'Zap' },
    { id: 'risk', label: 'Risk Analysis', icon: 'Shield' },
    { id: 'insights', label: 'Market Insights', icon: 'BarChart3' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'trading':
        return <TradingInterface />;
      case 'portfolio':
        return <PortfolioPanel />;
      case 'triggers':
        return <AutomatedTriggers />;
      case 'risk':
        return <RiskAssessment />;
      case 'insights':
        return <MarketInsights />;
      default:
        return <TradingInterface />;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>EUA Trading Hub - Carbon Cost Router</title>
        <meta name="description" content="Comprehensive EUA trading platform with real-time market data, portfolio management, automated triggers, and risk assessment tools for maritime carbon compliance." />
      </Helmet>
      <Header />
      <ComplianceAlertBanner />
      <div className="pt-16">
        <div className="flex items-center justify-between px-6 py-4 bg-card border-b border-border">
          <div className="flex items-center space-x-4">
            <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-lg">
              <Icon name="TrendingUp" size={24} strokeWidth={2} className="text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-foreground">EUA Trading Hub</h1>
              <p className="text-sm text-muted-foreground">
                Real-time trading, portfolio management, and risk assessment
              </p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <SystemStatusIndicator />
            <UserContextSwitcher />
          </div>
        </div>

        {/* Navigation Tabs */}
        <div className="bg-card border-b border-border">
          <div className="px-6">
            <nav className="flex space-x-8">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center space-x-2 py-4 px-2 border-b-2 font-medium text-sm transition-maritime ${
                    activeTab === tab?.id
                      ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'
                  }`}
                >
                  <Icon name={tab?.icon} size={16} strokeWidth={2} />
                  <span>{tab?.label}</span>
                </button>
              ))}
            </nav>
          </div>
        </div>

        {/* Main Content */}
        <main className="p-6">
          <div className="max-w-7xl mx-auto">
            {renderTabContent()}
          </div>
        </main>
      </div>
      <QuickActionToolbar />
    </div>
  );
};

export default EUATradingHub;